<template>
  <div class="ur-basic">
    <!-- Tab Bar -->
    <div class="ur-basic-tabbar">
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'housing' }"
        @click="activeTab = 'housing'"
      >
        {{ $t('URBANRENEWAL_ADMIN.HEATMAP.TAB_HOUSING') }}
      </button>
      <button
        class="ur-basic-tab"
        :class="{ 'is-active': activeTab === 'parking' }"
        @click="activeTab = 'parking'"
      >
        {{ $t('URBANRENEWAL_ADMIN.HEATMAP.TAB_PARKING') }}
      </button>
    </div>

    <!-- Tab Content -->
    <div class="ur-basic-content">
      <HousingHeatmap
        v-if="activeTab === 'housing'"
        :project-id="currentProjectId"
      />
      <ParkingHeatmap
        v-else-if="activeTab === 'parking'"
        :project-id="currentProjectId"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HousingHeatmap from './HousingHeatmap.vue';
import ParkingHeatmap from './ParkingHeatmap.vue';

export default {
  name: 'UrbanRenewalAdminHeatmap',

  components: { HousingHeatmap, ParkingHeatmap },

  data() {
    return {
      activeTab: 'housing',
    };
  },

  computed: {
    ...mapState('urbanRenewalAdmin', ['currentProjectId']),
  },
};
</script>
